import Vue from 'vue';
import VueRouter from 'vue-router';

const ResetPasswordForm = () => import('./components/password/ResetForm.vue');
const AcceptInvitation = () =>
  import('./components/registration/Index.vue');

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  base: '/devise',
  routes: [
    {
      name: 'resetPassword',
      path: '/password/reset',
      component: ResetPasswordForm,
    },
    {
      name: 'acceptInvitation',
      path: '/invitations/:token',
      component: AcceptInvitation,
    },
  ],
});
